import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d8ecb7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container weekReport"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "custom-title"
};
const _hoisted_4 = {
  class: "week"
};
const _hoisted_5 = {
  class: "date"
};
const _hoisted_6 = {
  class: "nums"
};
const _hoisted_7 = {
  class: "num"
};
const _hoisted_8 = {
  class: "box"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box-title"
}, "激活率", -1));
const _hoisted_10 = {
  class: "data-box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "项目总数据", -1));
const _hoisted_12 = {
  class: "box-conent"
};
const _hoisted_13 = {
  class: "text-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "任务总数：", -1));
const _hoisted_15 = {
  class: "text"
};
const _hoisted_16 = {
  class: "num month"
};
const _hoisted_17 = {
  class: "text-item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "已激活任务：", -1));
const _hoisted_19 = {
  class: "text"
};
const _hoisted_20 = {
  class: "num month"
};
const _hoisted_21 = {
  class: "text-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "待激活任务：", -1));
const _hoisted_23 = {
  class: "text"
};
const _hoisted_24 = {
  class: "num month"
};
const _hoisted_25 = {
  class: "text-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "激活率：", -1));
const _hoisted_27 = {
  class: "text"
};
const _hoisted_28 = {
  class: "num month"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  class: "box-conent"
};
const _hoisted_31 = {
  class: "text-item"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "新增终端：", -1));
const _hoisted_33 = {
  class: "text"
};
const _hoisted_34 = {
  class: "num week"
};
const _hoisted_35 = {
  class: "text-item"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "新增任务：", -1));
const _hoisted_37 = {
  class: "text"
};
const _hoisted_38 = {
  class: "num week"
};
const _hoisted_39 = {
  class: "text-item"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "本周激活任务：", -1));
const _hoisted_41 = {
  class: "text"
};
const _hoisted_42 = {
  class: "num week"
};
const _hoisted_43 = {
  class: "text-item"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "本周激活率：", -1));
const _hoisted_45 = {
  class: "text"
};
const _hoisted_46 = {
  class: "num week"
};
const _hoisted_47 = {
  class: "box"
};
const _hoisted_48 = {
  class: "box-item"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "本月", -1));
const _hoisted_50 = {
  class: "box-conent"
};
const _hoisted_51 = {
  class: "text-item"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "预计活跃次数：", -1));
const _hoisted_53 = {
  class: "text"
};
const _hoisted_54 = {
  class: "num month"
};
const _hoisted_55 = {
  class: "text-item"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "实际活跃次数：", -1));
const _hoisted_57 = {
  class: "text"
};
const _hoisted_58 = {
  class: "num month"
};
const _hoisted_59 = {
  class: "text-item"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "活跃率：", -1));
const _hoisted_61 = {
  class: "text"
};
const _hoisted_62 = {
  class: "num month"
};
const _hoisted_63 = {
  class: "box-item"
};
const _hoisted_64 = {
  class: "title"
};
const _hoisted_65 = {
  class: "box-conent"
};
const _hoisted_66 = {
  class: "text-item"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "预计活跃次数：", -1));
const _hoisted_68 = {
  class: "text"
};
const _hoisted_69 = {
  class: "num week"
};
const _hoisted_70 = {
  class: "text-item"
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "实际活跃次数：", -1));
const _hoisted_72 = {
  class: "text"
};
const _hoisted_73 = {
  class: "num week"
};
const _hoisted_74 = {
  class: "text-item"
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "活跃率：", -1));
const _hoisted_76 = {
  class: "text"
};
const _hoisted_77 = {
  class: "num week"
};
const _hoisted_78 = {
  class: "box"
};
const _hoisted_79 = {
  class: "box-title"
};
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务审核结果反馈", -1));
const _hoisted_81 = {
  class: "subTitle"
};
const _hoisted_82 = {
  class: "store-list"
};
const _hoisted_83 = {
  class: "left"
};
const _hoisted_84 = {
  class: "name"
};
const _hoisted_85 = {
  class: "address"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_group_columnar_chart = _resolveComponent("group-columnar-chart");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_no_more = _resolveComponent("no-more");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
    active: $data.week,
    "onUpdate:active": _cache[0] || (_cache[0] = $event => $data.week = $event),
    ref: "tabs",
    color: "#4f77aa",
    "swipe-threshold": 4,
    class: "custom-tabs",
    onClick: $options.getData
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekList, item => {
      return _openBlock(), _createBlock(_component_van_tab, {
        key: item.id,
        name: item.weekOrderNum
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "第" + _toDisplayString($data.weekMap[item.weekOrderNum - 1]) + "周", 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.startDate) + "-" + _toDisplayString(item.endDate), 1)])]),
        _: 2
      }, 1032, ["name"]);
    }), 128))]),
    _: 1
  }, 8, ["active", "onClick"]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" 项目执行计划终端总数： "), _createElementVNode("span", _hoisted_7, _toDisplayString($data.datas.monthStoreTotalCnt), 1), _createTextVNode(" 家 ")])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_group_columnar_chart, {
    data: $data.chartData1,
    id: "chart1",
    ref: "chart1"
  }, null, 8, ["data"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "box-item",
    onClick: _cache[1] || (_cache[1] = $event => $options.goActivation(false))
  }, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString($data.datas.monthTaskTotalCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString($data.datas.monthActivatedTaskCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString($data.datas.monthNoactivatedTaskCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString($options.formatPersent($data.datas.monthActivatedRate)), 1), _createTextVNode(" % ")])])])]), _createElementVNode("div", {
    class: "box-item",
    onClick: _cache[2] || (_cache[2] = $event => $options.goActivation(true))
  }, [_createElementVNode("div", _hoisted_29, "第 " + _toDisplayString($data.week) + " 周进度", 1), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, _toDisplayString($data.datas.increaseStoreCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString($data.datas.increaseTaskCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString($data.datas.weekActivatedTaskCnt), 1), _createTextVNode(" 个 ")])]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString($options.formatPersent($data.datas.weekActivatedRate)), 1), _createTextVNode(" % ")])])])])])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
    class: "box-title",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goActivityDetail && $options.goActivityDetail(...args))
  }, "活跃度"), _createVNode(_component_group_columnar_chart, {
    data: $data.chartData2,
    id: "chart2",
    ref: "chart2"
  }, null, 8, ["data"]), _createElementVNode("div", {
    class: "data-box",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goActivityDetail && $options.goActivityDetail(...args))
  }, [_createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [_createElementVNode("span", _hoisted_54, _toDisplayString($data.datas.monthPlanAttCnt), 1), _createTextVNode(" 次 ")])]), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, _toDisplayString($data.datas.monthFinishedAttCnt), 1), _createTextVNode(" 次 ")])]), _createElementVNode("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString($options.formatPersent($data.datas.monthAttRate)), 1), _createTextVNode(" % ")])])])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, "第 " + _toDisplayString($data.week) + " 周", 1), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString($data.datas.weekPlanAttCnt), 1), _createTextVNode(" 次 ")])]), _createElementVNode("div", _hoisted_70, [_hoisted_71, _createElementVNode("div", _hoisted_72, [_createElementVNode("span", _hoisted_73, _toDisplayString($data.datas.weekFinishedAttCnt), 1), _createTextVNode(" 次 ")])]), _createElementVNode("div", _hoisted_74, [_hoisted_75, _createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString($options.formatPersent($data.datas.weekAttRate)), 1), _createTextVNode(" % ")])])])])])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("div", _hoisted_81, "本周抽查终端数量：" + _toDisplayString($data.auditResultData.spotCheckCnt || 0), 1)]), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.auditResultData.terminalInfoList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "store-item",
      key: item.terminalCode
    }, [_createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, _toDisplayString(item.terminalName), 1), _createElementVNode("div", _hoisted_85, [_createVNode(_component_van_icon, {
      name: "location",
      color: "#999",
      size: "0.28rem",
      class: "icon"
    }), _createTextVNode(" " + _toDisplayString(item.province) + _toDisplayString(item.city), 1)])]), _createVNode(_component_router_link, {
      class: "btn",
      to: {
        path: '/auditResults',
        query: {
          terminalCode: item.terminalCode,
          week: $data.week,
          planCodeList: [...item.planCodeList]
        }
      }
    }, {
      default: _withCtx(() => [_createTextVNode("查看图片")]),
      _: 2
    }, 1032, ["to"])]);
  }), 128))])]), _createVNode(_component_no_more)]);
}